const TextRightActive = ({ quat }) => {
   return (
      <>
       

    <svg width="210" height="171" viewBox="0 0 210 171" fill="none" xmlns="http://www.w3.org/2000/svg">
<line y1="170.215" x2="210" y2="170.215" stroke="url(#paint0_linear_2001_186)" strokeWidth="1.56134"/>
<path d="M81.418 44.4998L162.833 91.5082L162.834 109.786L81.419 62.7773L81.418 44.4998Z" fill="#6E6E6E"/>
<path d="M0.00241039 91.5066L81.4174 44.4981L81.4164 62.7757L0.00137127 109.784L0.00241039 91.5066Z" fill="#5A5A5A"/>
<rect width="94.0117" height="94.0117" transform="matrix(0.866041 0.499972 -0.866041 0.499972 81.418 62.1226)" fill="#AAAAAA"/>
<path d="M0.000976562 91.5012L81.416 138.51L81.417 156.134L0.00201569 109.126L0.000976562 91.5012Z" fill="url(#paint1_linear_2001_186)"/>
<path d="M81.4184 138.508L162.833 91.4993L162.832 109.124L81.4174 156.132L81.4184 138.508Z" fill="url(#paint2_linear_2001_186)"/>
<rect x="0.866041" width="93.0117" height="93.0117" transform="matrix(0.866041 -0.499972 0.866041 0.499972 0.11699 91.9376)" fill="url(#paint3_linear_2001_186)" stroke="black"/>
<g opacity="0.6" filter="url(#filter0_f_2001_186)">
<ellipse cx="81.2907" cy="91.3036" rx="37" ry="6" transform="rotate(-29.7431 81.2907 91.3036)" fill="black"/>
</g>
<text transform="matrix(0.86601 -0.500028 -3.18907e-05 1 32.0098 42.1543)" fill="white" xmlSpace="preserve" style={{whiteSpace: "pre"}} fontSize="58.5502" fontWeight="800" letterSpacing="0em"><tspan x="0" y="56.791">{quat}</tspan></text>
<defs>
<filter id="filter0_f_2001_186" x="35.0254" y="58.2175" width="92.5308" height="66.1721" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
<feFlood floodOpacity="0" result="BackgroundImageFix"/>
<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
<feGaussianBlur stdDeviation="7" result="effect1_foregroundBlur_2001_186"/>
</filter>
<linearGradient id="paint0_linear_2001_186" x1="0" y1="171.496" x2="210" y2="171.496" gradientUnits="userSpaceOnUse">
<stop stopColor="white" stopOpacity="0.47"/>
<stop offset="1" stopColor="#020202"/>
</linearGradient>
<linearGradient id="paint1_linear_2001_186" x1="0.0012571" y1="100.313" x2="81.4153" y2="100.311" gradientUnits="userSpaceOnUse">
<stop stopColor="#FBFF3B"/>
<stop offset="1" stopColor="#AEC330"/>
</linearGradient>
<linearGradient id="paint2_linear_2001_186" x1="81.4177" y1="147.32" x2="162.832" y2="147.323" gradientUnits="userSpaceOnUse">
<stop stopColor="#AEC330"/>
<stop offset="1" stopColor="#FBFF3B"/>
</linearGradient>
<linearGradient id="paint3_linear_2001_186" x1="0" y1="47.0059" x2="94.0117" y2="47.0059" gradientUnits="userSpaceOnUse">
<stop stopColor="#FBFF3B"/>
<stop offset="1" stopColor="#AEC330"/>
</linearGradient>
</defs>
</svg>


      </>
   )
}
export default TextRightActive;
